@if (fc()?.errors?.required) {
  <ng-container i18n>El campo es obligatorio</ng-container>.
  {{ aditionalMessage('required') }}
}

@if (fc()?.errors?.pattern) {
  <ng-container i18n
    >Utiliza un formato que coincida con el solicitado</ng-container
  >.
  {{ aditionalMessage('pattern') }}
}

@if (fc()?.errors?.min) {
  <ng-container i18n>El valor debe ser superior o igual a</ng-container>
  {{ fc()?.errors?.min?.min }}.
  {{ aditionalMessage('min') }}
}

@if (fc()?.errors?.max) {
  <ng-container i18n>El valor debe ser inferior o igual a</ng-container>
  {{ fc()?.errors?.max?.max }}.
  {{ aditionalMessage('max') }}
}

@if (fc()?.errors?.email) {
  <ng-container i18n
    >Debe ser una dirección de correo electrónico válida</ng-container
  >.
  {{ aditionalMessage('email') }}
}

@if (fc()?.errors?.minlength) {
  <ng-container i18n>La longitud debe ser como mínimo</ng-container>
  {{ fc()?.errors?.minlength?.requiredLength }}
  <ng-container i18n>caracteres</ng-container>.
  {{ aditionalMessage('minlength') }}
}

@if (fc()?.errors?.maxlength) {
  <ng-container i18n>La longitud debe ser como máximo</ng-container>
  {{ fc()?.errors?.maxlength?.requiredLength }}
  <ng-container i18n>caracteres</ng-container>.
  {{ aditionalMessage('maxlength') }}
}

@if (fc()?.errors?.matDatepickerMin) {
  <ng-container i18n>Fecha no permitida, debe ser posterior</ng-container>.
  {{ aditionalMessage('matDatepickerMin') }}
}

@if (fc()?.errors?.matDatepickerMax) {
  <ng-container i18n>Fecha no permitida, debe ser anterior</ng-container>.
  {{ aditionalMessage('matDatepickerMax') }}
}

@if (fc()?.errors?.matchPassword) {
  <ng-container i18n>Las contraseñas no coinciden</ng-container>.
}

@if (fc()?.errors?.strongPassword) {
  <ng-container i18n>
    Usa mayúsculas, minúsculas, números y un carácter especial </ng-container
  >.
}

@if (fc()?.errors?.validateCheck || fc()?.errors?.validateImputation) {
  <ng-container i18n>La hora de fin debe ser mayor</ng-container>.
}

@if (fc()?.errors?.timezoneError) {
  <ng-container i18n>La zona horaria es incorrecta</ng-container>.
}

@if (fc()?.errors?.countryError) {
  <ng-container i18n>El país es incorrecto</ng-container>.
}

@if (fc()?.errors?.stateError) {
  <ng-container i18n>La provincia es incorrecta</ng-container>.
}

@if (fc()?.errors?.cityError) {
  <ng-container i18n>La ciudad es incorrecta</ng-container>.
}

@if (fc()?.errors?.invalidSumOfWeights) {
  <ng-container i18n>La suma de los pesos debe ser igual a 100</ng-container>.
}

@if (fc()?.errors?.invalidWeekMultiple) {
  <ng-container i18n
    >La fecha de fin debe coincidir con el mismo día de la semana que el
    inicio.</ng-container
  >.
}

@if (fc()?.errors?.maxWeeksExceeded) {
  <ng-container i18n
    >No puedes exceder el máximo de semanas permitidas.</ng-container
  >.
}
